import React from 'react';
import { Page } from 'shared';
import './profile-page.scss';

export default function ProfilePage(props) {
  return (
    <Page {...props} className="profile-page-component nested-page-content" />
  );
}
